import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function UploadFailed() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const ticketId = searchParams.get("ticketId");

  return (
    <div className="container">
      <div className="card">
        <div className="header">
          <h1>Upload Failed</h1>
        </div>
        <div className="content">
          <p>Unfortunately, none of your files could be uploaded.</p>
          <p>Please check your file formats and sizes, then try again using the link provided in your email.</p>
          {ticketId && (
            <div className="ticket-id-display">Ticket ID: #{ticketId}</div>
          )}
          <button className="submit-btn" onClick={() => navigate(-1)} style={{marginTop: '1rem'}}>Go Back</button>
        </div>
      </div>
      <footer>
        <p>HubSpot Dispute-Document Upload Portal &copy; 2025</p>
      </footer>
    </div>
  );
}
